import { emailsService } from '@afterpaytouch/portal-api/consumer/emails'

export const { useUnsubscribeFromEmailMutation } = emailsService
